import React, { useEffect, useState, useRef } from "react";
import styles from "./PretestButton.module.scss";
import { Button, message } from "antd";
import { TranslateLanguage } from "util/Translate";
import { vocabPretestButton } from "util/Translate.variable";
import dayjs from "dayjs";

const translate = new TranslateLanguage();
translate.addMaping(vocabPretestButton);

export const textPretestButton = (pretest, AllStatus, isLoading) => {
  if (isLoading) {
    return translate.convert("กำลังโหลด");
  }
  if (
    pretest?.continuePretest === true ||
    JSON.parse(localStorage.getItem(pretest?.id))
  ) {
    return <span>{translate.convert("ทำต่อ")}</span>;
  }
  if (AllStatus) {
    const doPretest = AllStatus.find(
      (status) =>
        status === "passTesting:2" ||
        status === "passTesting:true" ||
        status === "isPurchased:2"
    );
    if (doPretest && pretest.isPurchase) {
      return translate.convert("ฝึกทำข้อสอบ");
    }
    const purchased = AllStatus.find(
      (stutus) => stutus === "isPurchased:0" || stutus === "isPurchased:1"
    );
    if (purchased) {
      return translate.convert("เริ่มทำข้อสอบ");
    }
    if (pretest.price.cash) {
      return `${pretest.price.cash} ${translate.convert("บาท")}`;
    }

    return translate.convert("฿ 0");
  }
  return "";
};
export const isPretestDisabled = () => {};

export const PretestTestingButton = (props) => {
  const { isDisableActionBtn, handleClick, AllStatus, pretest, isLoading } =
    props;
  const [text, setText] = useState("");
  const [countdown, setCountdown] = useState({
    type: undefined,
    value: undefined,
  });
  const timerRef = useRef(null);

  useEffect(() => {
    if (pretest) {
      const now = dayjs().unix();
      const status = textPretestButton(pretest, AllStatus, isLoading);

      if (status !== "ฝึกทำข้อสอบ" || status !== "เริ่มทำข้อสอบ") {
        const countdown = pretest.saleDate - now;
        setCountdown({
          type: "waitSale",
          value: countdown,
        });
      }
      if (status === "เริ่มทำข้อสอบ") {
        const countdown = pretest?.durationPretest?.start - now;
        setCountdown({
          type: "waitTest",
          value: countdown,
        });
      }

      setText(textPretestButton(pretest, AllStatus, isLoading));
    }
  }, [isLoading, AllStatus, pretest]);

  useEffect(() => {
    if (countdown?.value > 0) {
      timerRef.current = setInterval(() => {
        setCountdown((prev) => {
          if (!prev || !prev.value || prev.value <= 1) {
            clearInterval(timerRef.current);
            return { ...prev, value: 0 };
          }
          return { ...prev, value: prev.value - 1 };
        });
      }, 1000);
    }

    return () => clearInterval(timerRef.current); // cleanup
  }, [countdown?.value]);

  const formatTime = (totalSeconds) => {
    const secondsInMonth = 30 * 24 * 60 * 60;
    const secondsInDay = 24 * 60 * 60;
    const secondsInHour = 60 * 60;
    const secondsInMinute = 60;

    let remaining = totalSeconds;

    const months = Math.floor(remaining / secondsInMonth);
    remaining %= secondsInMonth;

    const days = Math.floor(remaining / secondsInDay);
    remaining %= secondsInDay;

    const hours = Math.floor(remaining / secondsInHour);
    remaining %= secondsInHour;

    const minutes = Math.floor(remaining / secondsInMinute);
    const seconds = remaining % secondsInMinute;

    const time = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(seconds).padStart(2, "0")}`;

    const parts = [];
    if (months > 0) parts.push(`${months} เดือน`);
    if (days > 0 || months > 0) parts.push(`${days} วัน`);

    parts.push(time);

    return parts.join(" ");
  };

  const handleClickST = () => {
    const now = dayjs().unix();

    if (
      pretest.canPractice
        ? true
        : pretest.durationPretest.start + pretest.pretestTime * 60 > now
    ) {
      return handleClick();
    } else {
      message.error("เลยเวลารอบจริง").then(() => {
        window.location.reload();
      });
    }
  };

  return (
    <Button
      button-itemid="startTesting"
      type="primary"
      loading={isLoading}
      className={styles.btnPrimary}
      disabled={isDisableActionBtn()}
      onClick={handleClickST}
    >
      {countdown.value > 0 ? (
        countdown.type === "waitTest" ? (
          <>เริ่มสอบใน {formatTime(countdown.value)}</>
        ) : countdown.type === "waitSale" ? (
          <>เริ่มจำหน่ายใน {formatTime(countdown.value)}</>
        ) : (
          <>{text}</>
        )
      ) : (
        <>{text}</>
      )}
    </Button>
  );
};
